import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpHeroSectionRendererWidgetData } from './types';
import { CpHeroSectionFullBackground } from './variants/hero-section-full-background';
import { CpHeroSectionImageAtBottom } from './variants/hero-section-image-at-bottom';
import { CpHeroSectionImageAtCenter } from './variants/hero-section-image-at-center';

export const CpHeroSection: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(
    () => data as CpHeroSectionRendererWidgetData,
    [data],
  );

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.HeroSectionFullBackground:
    case undefined:
      return (
        <CpHeroSectionFullBackground
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.HeroSectionWithImageAtBottom:
      return (
        <CpHeroSectionImageAtBottom
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
          disabled={disabled}
        />
      );
    case CpWidgetVariantType.HeroSectionWithImageAtCenter:
      return (
        <CpHeroSectionImageAtCenter
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
          disabled={disabled}
        />
      );
    default:
      return <></>;
  }
};
